import React from 'react';
import {DeviceType} from '../../../../../incase-domain/common/DeviceType.enum';
import ConfusionMatrix from '../../../../../incase-domain/components/report/answer/matchPair/confusionMatrix/ConfusionMatrix';
import {QuestionReport} from '../../../../../incase-domain/analytics';
import {useLayout} from '../../../../../hooks/useLayout';
import ReportAnswerMatchPair from '../../../../../incase-domain/components/report/answer/matchPair/ReportAnswerMatchPair';

interface IMatchPairQuestionReportProps {
    device: DeviceType;
    questionReport: QuestionReport;
}

function MatchPairQuestionReport({questionReport, device}: IMatchPairQuestionReportProps): JSX.Element {
    const {matchPairsReport} = questionReport;

    const {mobileView} = useLayout();

    return (
        <>
            <div
                className={`c-questionReport__match-pairs-report ${
                    device === DeviceType.MOBILE
                } c-questionReport__match-pairs-report-mobile`}
            >
                {matchPairsReport &&
                    (mobileView ? (
                        <ReportAnswerMatchPair matchPairReport={matchPairsReport} />
                    ) : (
                        <ConfusionMatrix matchPairReport={matchPairsReport} showPercentages />
                    ))}
            </div>
        </>
    );
}

export default MatchPairQuestionReport;
